import { OrderedMap } from 'immutable';

import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';

const initialState = OrderedMap();

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD:
      return state.set(action.form.id, action.form);

    case ADD_MULTIPLE:
      return state.merge(action.forms);

    case UPDATE:
      return state.set(action.form.id, action.form);

    case REMOVE:
      return state.delete(action.id);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
